import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const EXAMEN_URL = `${backendUrl}/api/examen/`;

class ExamenService {
	async getAllExamens() {
		try {
			const response = await axios.get(EXAMEN_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getExamen(id) {
		return axios.get(`${EXAMEN_URL}${id}/`);
	}

	createExamen(data) {
		return axios.post(EXAMEN_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateExamen(id, data) {
		return axios.put(`${EXAMEN_URL}${id}/`, data);
	}

	deleteExamen(id) {
		return axios.delete(`${EXAMEN_URL}${id}/`);
	}

	getExamenOptions() {
		return this.getAllExamens().then((examens) => {
			return examens.map((examen) => ({
				value: examen.id,
				label: 'Examen Mensuel N°' + examen.exam_type
			}));
		});
	}
}

export default new ExamenService();
